import { useMemo } from "react";
import DropdownMenu, { type IDDItem } from "../../components/common/DropdownMenu";
import Input from "./MaterialBalanceInput";
import { OuterData } from "../../components/common/OuterData";
import { useAppSelector, useAppDispatch } from "../../store/hooks/hooks";
import { setPressureAbandon, setPressureAbandonUnit } from "../../store/slices/materialBalanceCalculatorSlice";
import { getDataForMaterialBalance } from "../../store/slices/pvtCalculatorSlice";
import { Trans } from "react-i18next";
import { unitConverter } from "../../components/MeasurementUnits/UnitConverter";
import type { pressureUnitId } from "../../interfaces/interfaces";

const PressureAbandondedAndPvt = () => {
	const pvtData = useAppSelector(getDataForMaterialBalance);
	const input = useAppSelector(state => state.materialBalance.pressureAbandon);
	const dispatch = useAppDispatch();

	const onInputChange = (_: string, value: number | null, isIncomplete?: boolean) => {
		dispatch(setPressureAbandon({ value, isIncomplete }));
	};

	const showHints = useAppSelector(state => state.settings.showHints);

	const tooltipContent = useMemo(() => {
		if (!showHints) {
			return undefined;
		}

		return (
			<Trans
				ns={'ipr'}
				i18nKey={`form_field_titles.${input?.queryName}`}
				components={{
					sub: <sub />,
					sup: <sup />,
				}}
			/>
		);
	}, [showHints, input?.queryName]);

	const ddInputs: IDDItem[] = useMemo(() => {
		const units = unitConverter.getUnitsByCategory(input.unitCategoryId);
		return units.map(unit => ({
			id: unit.id,
			translationKey: `measurement_units.${unit.category}.${unit.id}`
		} as IDDItem));

	}, [input]);

	const onDDSelectItem = (itemId: string) => {
		dispatch(setPressureAbandonUnit({ toUnitId: itemId as pressureUnitId }));
	};

	const value: number | null = useMemo(() => {
		if (input.currentValue == null)
			return null;

		if (input.currentUnitId != null && input.currentUnitId === input.userUnitId && input.userValue != null)
			return input.userValue;

		return parseFloat(input.currentValue.toFixed(4));
	}, [input]);

	return (
		<div>
			<div className="ipr__input-group">
				<Input
					value={value}
					onChange={onInputChange}
					name={input.queryName}
					id={input.id}
					tooltip={tooltipContent}
					error={input.error}
					errorParams={input.errorParams}
				/>
				{input.unitCategoryId && input.currentUnitId && (
					<DropdownMenu
						inputId={input.id}
						items={ddInputs}
						selectedItemId={input.currentUnitId}
						onSelect={onDDSelectItem}
					/>)
				}
			</div>
			<OuterData
				inputs={pvtData.inputs}
				errors={pvtData.errors}
				translationNamespace="pvt"
			/>
		</div>
	);
};

export default PressureAbandondedAndPvt;